/**
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */
RCA.client.Notifications = (function () {
    'use strict';

    var $templateNotificationsItem;

    function Init() {
        $templateNotificationsItem = $('template#tplNotificationsItem').remove().contents();
        renderList();
        delete RCA.client.Notifications.Init;
    }

    function renderList() {
        var
            $self = $('#notifications .notificationsList'),
            $fragmentNotifications = $(document.createDocumentFragment()),
            data;

        (RCA.shared.AppData.pushednotifications || []).sort(function (a, b) {
            return (a.pushed_date > b.pushed_date) ? -1 : 1;
        });

        $.each(RCA.shared.AppData.pushednotifications, function (i, el) {
            data = RCA.shared.AppData.notifications.filter(function(e) {
                return e.id === el.notification_id;
            })[0];
            if(data !== undefined) {
                var $clone = $templateNotificationsItem.clone();
                $clone.attr('data-index', data.id);
                $clone.find('.data-title').text(data.title[RCA.shared.localState.lang]);
                $clone.find('.data-info').text(data.text[RCA.shared.localState.lang]);
                $clone.find('.data-pusheddate').text(el.pushed_date);
                $clone.appendTo($fragmentNotifications);
            }
        });
        $self.html($fragmentNotifications);
        $('#notifications').find('.no-result').toggle(!RCA.shared.AppData.notifications.length);
    }

    function renderDetails() {
        var dataindex = this.dataset.index;
        var notification = RCA.shared.AppData.notifications.filter(function(e) {
            return e.id === dataindex;
        });
        notification[0].canClose = true;
        RCA.client.Modal.notification(notification[0]);
    }

    function showList() {
        BuildFromSource();
    }

    function showDetails(id) {
        if (id) {
            if (RCA.shared.localState.notifications != undefined) {
                if (id !== RCA.shared.localState.notifications.itemIndex || RCA.shared.localState.notifications.itemIndex === 0) {
                    RCA.shared.localState.notifications.itemIndex = String(id);
                    renderDetails();
                }
            } else {
                RCA.shared.localState.notifications = { 'itemIndex': String(id)};
            }
            RCA.client.Layout.show('notifications-details');
        }
    }

    function BuildFromSource() {

        $.post('api/', {
            'do': 'getPushedNotifications'
        }, function(data) {
            RCA.shared.AppData.pushednotifications = data;
            renderList();
        });
    }

    $(document)
        .on('click', '#notifications .item', renderDetails);
    return {
        Init: Init,
        showDetails:showDetails,
        showList:showList,
        renderList:renderList,
        BuildFromSource:BuildFromSource
    }
})();
